// ctx-strict-property-migration
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { YouTubeElement } from './youtube-element';
YouTubeElement;

import './ctx-card';

//https://codingyaar.com/bootstrap-video-card/
//render root is dom and we need bootstrap css for now

@customElement('youtube-card')
export class YouTubeCard extends LitElement {
  @property() title!: string;
  @property() videoid!: string;

  static styles = [
    css`
    h5 {
      margin-block-start: 0;
    }
  `]

  render() {
    return html`
      <ctx-card heading=${this.title} style="--card-background-color:white">
        <youtube-element videoid="${this.videoid}" slot=media></youtube-element>
      </ctx-card>
      `;
  }

}